export interface Point {
  latitude: number;
  longitude: number;
}

const EARTH_RADIUS_METERS = 6371000;
/** A phone reporting a huge accuracy cannot excuse more than this much distance. Same cap as core-api. */
const ACCURACY_CAP_METERS = 100;
export const DEFAULT_OFFICE_RADIUS_METERS = 500;

const toRadians = (degrees: number) => (degrees * Math.PI) / 180;

/** Great-circle distance in metres. */
export const haversineMeters = (a: Point, b: Point): number => {
  const dLat = toRadians(b.latitude - a.latitude);
  const dLng = toRadians(b.longitude - a.longitude);
  const h = Math.sin(dLat / 2) ** 2 + Math.cos(toRadians(a.latitude)) * Math.cos(toRadians(b.latitude)) * Math.sin(dLng / 2) ** 2;
  return 2 * EARTH_RADIUS_METERS * Math.asin(Math.min(1, Math.sqrt(h)));
};

/** Distance from the office after crediting the GPS accuracy (at most 100 m). Never negative. */
export const distanceFromOfficeMeters = (capture: Point & { accuracy?: number | null }, office: Point): number => {
  const credit = Math.min(Math.max(0, capture.accuracy ?? 0), ACCURACY_CAP_METERS);
  return Math.max(0, haversineMeters(capture, office) - credit);
};

/** "850 m" under 1 km, else one decimal in km ("4.2 km"). */
export const formatDistance = (meters: number): string => (meters < 1000 ? `${Math.round(meters)} m` : `${(meters / 1000).toFixed(1)} km`);
